<template>
  <div class="tile">
    <PinchInImg v-show="showPinchIn"/>
    <!-- 問題表示欄 -->
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

        <template v-if="isEnvironmentPc()">

          <div class="toparea-text">
            <div class="flexstretch" v-show="showSelectAnswer">
              <div v-for="(text, key) in selectAnswers" :key="key"
                   class="item w200" :class="[getTextFontSize(text), { 'active': activeCorrectAnswer(text) }]"
                   @click="checkAnswer(text)">
                <span v-html="getPopupTextElem(text)"></span>
              </div>
            </div>
          </div>

          <div class="cards-container active-type3" >
            <div v-for="(group, groupIndex) in actGroupIndexList" :key="groupIndex"
                 class="card-voice card-inner" :class="templateType(groupIndex)">
              <template v-for="actIndex in group">
                <div class="item" :class="{ active: isActActive(actIndex), disabled: isActDisabled(actIndex) }" @click="audioReplay(actIndex)" :key="actIndex">
                  <div class="select" :class="[getTextFontSize(actList[actIndex].basicTextDeleteTag)]">
                    <template>
                      <span v-html="actList[actIndex].japaneseText" v-show="dispJapaneseStatus" />
                      <span v-html="actList[actIndex].questionText" v-show="showQuestionText(actIndex)" />
                      <span v-html="actList[actIndex].answerText" v-show="showAnswerText(actIndex)"/>
                    </template>
                  </div>
                  <div class="card">
                    <div v-if="isShowCorrectImg(actIndex) || isShowIncorrectImg(actIndex)" :class="{correct : isShowCorrectImg(actIndex), incorrect : isShowIncorrectImg(actIndex)}" ></div>
                    <div class="image"><img :src="actList[actIndex].image"></div>
                    <button class="icon-voice" @click="audioReplay(actIndex)" :disabled="disableReplayButton(actIndex)"></button>
                  </div>
                </div>
              </template>
            </div>
          </div>

        </template>
        <template v-else>

          <div class="toparea-text">
            <div class="flexstretch" :style="{ visibility: showSelectAnswer ? 'visible' : 'hidden' }">
              <div v-for="(text, key) in selectAnswers" :key="key"
                   class="item w200" :class="{ 'active': activeCorrectAnswer(text) }" @click="checkAnswer(text)">
                <span v-html="text" />
              </div>
            </div>
          </div>

          <div class="cards-container swiper-container swiper-container1 active-type3">
            <div class="swiper-wrapper">
              <div v-for="(group, groupIndex) in actGroupIndexList" :key="groupIndex"
                   class="card-inner card-voice swiper-slide" :class="templateType(groupIndex)">

                <div class="swiper-container swiper-container2">
                  <div class="swiper-wrapper">
                    <div v-for="actIndex in group" :key="actIndex"
                         class="item swiper-slide" :class="{ active: isActActive(actIndex), disabled: isActDisabled(actIndex) }"
                         @click="audioReplay(actIndex)">
                      <div class="select">
                        <template>
                          <span v-html="actList[actIndex].japaneseText" v-show="dispJapaneseStatus" />
                          <span v-html="actList[actIndex].questionText" v-show="showQuestionText(actIndex)" />
                          <span v-html="actList[actIndex].answerText" v-show="showAnswerText(actIndex)" />
                        </template>
                      </div>
                      <div class="card">
                        <div v-if="isShowCorrectImg(actIndex) || isShowIncorrectImg(actIndex)" :class="{correct : isShowCorrectImg(actIndex), incorrect : isShowIncorrectImg(actIndex)}"></div>
                        <div class="image" @touchstart="onTouchStart(actList[actIndex].image)"
                              @touchend="onTouchEnd()" @touchmove="onTouchEnd()"><img :src="actList[actIndex].image"></div>
                        <button class="icon-voice" @click="audioReplay(actIndex)" :disabled="disableReplayButton(actIndex)"></button>
                      </div>
                    </div>  
                  </div>
                </div>

              </div>
            </div>
          </div>

        </template>

      </div>
    </div>
  </div>
</template>
<script>
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

var lodash = require("lodash");

// 画像拡大モーダルコンポーネント
import PinchInImg from "./PinchInImg";

export default {
  name: "Tile",
  mixins: [
    common,
    runmode
  ],
  data() {
    return {
      // actのグループごとの配列
      actGroupIndexList: [],
      // 正解act index
      correctIndex: [],
      // 不正解act index
      incorrectIndex: [],
      // 回答選択欄表示フラグ
      showSelectAnswer: false,
      // 回答音声再生中フラグ
      isAudioAnswerPlaing: false,
      // 選択回答一覧表示用
      selectAnswers: [],
      // 現在のACTの回答一覧
      currentAnswers: [],
      // 現在のACTの選択肢index
      currentSelectIndex: 0,
      // 回答済ACT index
      finishActIndex: [],
      // 正解画像表示フラグ
      showCorrectImg: false,
      // 不正解画像表示フラグ
      showIncorrectImg: false,
      // 回答済ACTの選択肢index
      finishActAnswerIndex: {},
      inncorectTimer: null,
      // リプレイボタン非活性
      disableAudioReplay: true,
      // 正解音再生中
      isCorrectPlaying: false,
      // 不正解再生中
      isIncorrectPlaying: false,
      // 次ACT表示タイマー
      nextTimer: null,
      // 開始待ち
      waitingStart: false,
      actList: null,
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  components: {
    PinchInImg
  },
  methods: {
    getObjectSize: function(obj) {
      var a = 1;
      if (obj === undefined) {
        return a;
      }
      a = obj.length;
      if (a === undefined) {
        a = 1;
      }
      return a;
    },
    // スライドさせる
    slide: function(num) {
      this.log("---- slide(" + num + ") ----");

      if (this.isEnvironmentPc()) {
        return;
      }

      this.log("------- swipe:" + num + " ------");
      this.log("------- swiperIn:" + this.swiperIn + " ------");

      var cnt = this.getObjectSize(this.swiperIn);

      if (cnt === 1) {
        this.log("----- check1 !! ----");
        this.log("swiperIn=" + this.swiperIn);
        this.swiperIn.slideTo(num);
      } else {
        this.log("----- check2 !! ----");

        var off = 0;

        this.log("---- this.acts=" + this.actGroupIndexList + " -----");

        this.log("---- acts[" + off + "].length=" + this.getObjectSize(this.actGroupIndexList[off]));
        while (off < cnt && this.getObjectSize(this.actGroupIndexList[off]) <= num) {
          num -= this.getObjectSize(this.actGroupIndexList[off]);
          off++;
          this.log("num=" + num + " off=" + off);
        }
        this.swiperOut.slideTo(off);
        this.swiperIn[off].slideTo(num);
      }
    },
    init: function() {
      const self = this;
      // グループごとにactをまとめた配列を生成
      var groupIndexList = this.getItems();
      if (this.pathstep.groupNum == 0) {
        // グループなしの場合
        this.actGroupIndexList = [groupIndexList];
      } else {
        // グループありの場合
        this.actGroupIndexList = groupIndexList;
      }
      // ACTの要素編集
      this.editAct();
      // 正解音終了処理
      this.myAudioCollect.onended = function() {
        self.audioCollectEnded();
      };
      // 初回音声再生
      if (this.lessonState == constants.LESSON_STATE_START) {
        // STARTの場合、初回音声再生
        this.timer = setTimeout(function() {
          self.divideChallenge();
        }, 1000);
      } else {
        this.waitingStart = true;
      }

      if (!this.isEnvironmentPc()) {
        this.$nextTick(function() {
          self.log("this.pathstep=" + JSON.stringify(this.pathstep));
          self.sliderInit();
        });
      }
    },
    editAct: function() {
      // ACTの内容を編集
      this.actList = _.clone(this.pathstep.acts);
      for (var i = 0; i < this.actList.length; i++) {
        // 問題テキスト
        this.actList[i].questionText = "";
        // 回答テキスト
        this.actList[i].answerText = "";
        var questionTextList = this.getQuestionTextList(this.actList[i].basicText);
        // HTMLタグ削除後の英文
        this.actList[i].basicTextDeleteTag = this.getBasicText(this.actList[i].basicText);
        // チャレンジ判定
        this.actList[i].isChallenge = this.isChallenge(this.actList[i]);
        // 回答
        var answer = "";
        for (var j = 0; j < questionTextList.length; j++) {
          if (questionTextList[j].isSelect) {
            // 選択肢
            answer += "<span>" + this.getPopupTextElem(this.getAnswerText(questionTextList[j].text)) + " </span>";
          } else {
            // 英文
            answer += questionTextList[j].text;
          }
        }
        this.actList[i].answerText = answer;
        var question = "";
        for (var j = 0; j < questionTextList.length; j++) {
          if (questionTextList[j].isSelect) {
            // 選択肢
            question += '<span class="input" id="tile_select_area_' + i + "_" + questionTextList[j].selectIndex + '"></span>';
          } else {
            // 英文
            question += questionTextList[j].text;
          }
        }
        this.actList[i].questionText = question;
      }
    },
    audioCollectEnded: function() {
      // 正解音終了処理
      this.isCorrectPlaying = false;
      // 正解音声再生
      if (this.checkActAllAnswer()) {
        // 選択肢全て正解
        // 正解画像非表示
        this.showCorrectImg = false;
        // 再生中の場合、停止
        this.audioPlaying = false;
        this.isAudioReplay = false;
        // 正解音声再生
        this.audioAnswerPlay(this.currentActIndex);
      }
    },
    finishAct: function(index) {
      return _.includes(this.finishActIndex, index);
    },
    showAnswer: function(index, selectIndex) {
      // 回答の表示
      return this.finishActAnswerIndex[index] && _.includes(this.finishActAnswerIndex[index], selectIndex);
    },
    audioEnded: function() {
      const self = this;
      // オーディオ終了時の処理
      if (this.isAudioAnswerPlaing && !this.isAudioReplay) {
        // 正解時の音声再生終了
        // 次のACT表示
        this.nextTimer = setTimeout(function() {
          self.nextAct();
        }, 1000);
      } else if (!this.isAudioAnswerPlaing && !this.isAudioReplay) {
        this.disableAudioReplay = false;
      }
      this.isAudioAnswerPlaing = false;
      this.isAudioReplay = false;
    },
    nextAct: function() {
      // 次のACT表示
      const self = this;
      this.nextTimer = null;
      if (this.setNextAct(function() {
        // 音声再生
        this.divideChallenge();

        this.slide(this.currentActIndex);
      })) {
      } else {
        // pathstep終了
        // リプレイ非活性
        this.disableAudioReplay = true;
        this.setInterval(mixinConstants.ALLCORRECT_INTERVAL).then(function() {
          self.$emit("endAct");
        });
      }
    },
    divideChallenge: function() {
      // 回答有無振り分け
      // リプレイ非活性
      this.disableAudioReplay = true;
      if (this.isChallenge(this.currentAct)) {
        // 回答あり
        // 問題音声再生
        this.audioQuestionPlay(this.currentActIndex);
        this.showSelectAnswer = true;
        // 現在の問題の選択肢index
        this.currentSelectIndex = 0;
        // 現在の問題の回答一覧取得
        this.currentAnswers = this.getSelectList(this.currentAct.basicText);
        // 選択肢生成
        this.selectAnswers = _.shuffle(this.currentAnswers[this.currentSelectIndex]);
      } else {
        // 回答なし
        // 回答音声再生
        this.audioAnswerPlay(this.currentActIndex);
      }
    },
    checkAnswer: function(selected) {
      // 回答チェック
      if (this.dispAllAnswerStatus == true || this.dispJapaneseStatus == true) {
        // 全解答表示中、日本語表示中は何もしない
        return;
      }
      const self = this;
      var answer = this.currentAnswers[this.currentSelectIndex][0];
      this.showCorrectImg = false;
      this.showIncorrectImg = false;
      if (selected === answer) {
        // 正解選択肢の番号セット
        if (!this.finishActAnswerIndex[this.currentActIndex]) {
          // ACTで初回の場合はオブジェクト生成
          this.finishActAnswerIndex[this.currentActIndex] = [];
        }
        this.finishActAnswerIndex[this.currentActIndex].push(this.currentSelectIndex);
        // 選択エリアに正解文表示
        var dispAnswer = answer + " ";
        $("#tile_select_area_" + this.currentActIndex + "_" + this.currentSelectIndex).html(this.getPopupTextElem(dispAnswer)).removeClass("input");
        // 全ての選択肢を正解の場合
        if (this.checkActAllAnswer()) {
          // 音声停止
          this.runmodeAudioPause();
          this.isAudioReplay = false;
          // リプレイ非活性
          this.disableAudioReplay = true;
          // 選択肢非表示
          this.showSelectAnswer = false;
          // 正解画像表示
          this.showCorrectImg = true;
          // 正解配列にindex追加（すでに不正解してない場合）
          if (!_.includes(this.incorrectIndex, this.currentActIndex)) {
            this.correctIndex.push(this.currentActIndex);
            // 正解数更新
            this.setActState(true);
          }
          // 正解表示配列にACTのindex追加
          this.finishActIndex.push(this.currentActIndex);
          // 正解音再生
          this.isCorrectPlaying = true;
          this.audioAnswerCollect();
        } else {
          // 選択肢のindexを更新
          this.currentSelectIndex++;
          // 選択肢生成
          this.selectAnswers = _.shuffle(this.currentAnswers[this.currentSelectIndex]);
        }
      } else {
        // 不正解
        // 不正解音再生
        this.audioAnswerIncorrect();
        // 不正解画像表示
        this.showIncorrectImg = true;
        clearTimeout(this.inncorectTimer);
        this.inncorectTimer = setTimeout(function() {
          self.showIncorrectImg = false;
        }, this.incorrectImageDuration);
        // 不正解配列にindex追加
        if (!_.includes(this.incorrectIndex, this.currentActIndex)) {
          this.incorrectIndex.push(this.currentActIndex);
          // 不正解数更新
          this.setActState(false);
        }
      }
    },
    audioQuestionPlay: function(index) {
      // 問題音声再生
      this.audioPlay(this.pathstep.acts[index].sounds[1]);
    },
    audioAnswerPlay: function(index) {
      // 回答音声再生
      this.isAudioAnswerPlaing = true;
      this.audioPlay(this.pathstep.acts[index].sounds[0]);
    },
    audioReplay: function(index) {
      if (this.disableReplayButton(index)) {
        // リプレイ非活性
        return;
      }
      this.isAudioReplay = true;
      if (this.isChallenge(this.pathstep.acts[index]) == 0 || _.includes(this.finishActIndex, index)) {
        // 回答なしまたは回答済
        this.audioAnswerPlay(index);
      } else {
        // 未回答
        this.audioQuestionPlay(index);
      }
    },
    checkActAllAnswer: function() {
      // ACTが終了かチェック
      return this.finishActAnswerIndex[this.currentActIndex].length === this.currentAnswers.length;
    },
    getQuestionTextList: function(text) {
      // 問題テキストを分解して配列で返す
      // テキストをスペースで分解
      var textList = text.replace(/\[/g, "####[").replace(/\]/g, "]####").split("####");
      // 戻り値
      var ret = [];
      // 選択肢番号
      var selectIndex = 0;

      for (var i = 0; i < textList.length; i++) {
        var obj = {
          // 文言
          text: "",
          // 選択肢か否か
          isSelect: false,
          // 選択肢番号
          selectIndex: 0
        };
        if (this.isSelectList(textList[i])) {
          // 選択肢
          obj.text = textList[i].trim();
          obj.isSelect = true;
          obj.selectIndex = selectIndex++;
        } else {
          // タグ区切り
          var textList2 = textList[i].split(/\s*(<[^>]*>)/g);
          obj.text = "";
          for (var j = 0; j < textList2.length; j++) {
            if (textList2[j].match(/<([^>]*)>/g)) {
              // タグ
              obj.text += textList2[j].trim();
            } else {
              // 単語
              // スペース区切り
              var textList3 = textList2[j].trim().split(/\s+(?![^<>]*>)/g);
              obj.text += "<span>" + this.getPopupTextElem(textList3.join(" ")) + " </span>";
            }
          }
        }
        ret.push(obj);
      }
      return ret;
    },
    getBasicText: function(text) {
      // タグ等取り除いた英文
      var textList = text.replace(/<.+?>/g, "").replace(/\[/g, "####[").replace(/\]/g, "]####").split("####");
      var ret = "";
      for (var i = 0; i < textList.length; i++) {
        if (this.isSelectList(textList[i])) {
          var match = textList[i].replace(/\[|\]/g, "").split("/");
          if (match[0]) {
            ret += match[0];
          }
        } else {
          ret += textList[i];
        }
      }
      return ret;
    },
    getAnswerText: function(text) {
      // 正解文
      var textList = text.replace(/\[/g, "####[").replace(/\]/g, "]####").split("####");
      var ret = "";
      for (var i = 0; i < textList.length; i++) {
        if (this.isSelectList(textList[i])) {
          ret += this.getSelectAnswer(textList[i]);
        } else {
          ret += textList[i];
        }
      }
      return ret;
    },
    isSelectList: function(text) {
      // 選択項目チェック
      return text.match(/\[([^\]]*)\]/g);
    },
    getSelectList: function(text) {
      // 選択項目のリスト生成
      var match = text.match(/\[([^\]]*)\]/g);
      if (!match || match.length == 0) {
        return [];
      }
      var ret = [];
      for (var i = 0; i < match.length; i++) {
        var arr = match[i].replace(/\[|\]/g, "").split("/");
        ret.push(arr);
      }
      return ret;
    },
    getSelectAnswer: function(text) {
      // 正解テキストを取得
      var list = this.getSelectList(text.trim());
      if (list[0] && list[0][0]) {
        // リストの最初の値が正解
        return list[0][0];
      }
      return "";
    },
    isActActive: function(index) {
      // Actが選択中かチェック
      return index === this.currentActIndex;
    },
    isActDisabled: function(index) {
      // Actが非活性かチェック
      return index > this.currentActIndex;
    },
    isShowCorrectImg: function(index) {
      // 正解画像表示制御
      return this.isActActive(index) && this.showCorrectImg;
    },
    isShowIncorrectImg: function(index) {
      // 不正解画像表示制御
      return this.isActActive(index) && this.showIncorrectImg;
    },
    disableReplayButton: function(index) {
      // リプレイ非活性
      return this.audioPlaying || this.isActDisabled(index) || this.disableAudioReplay;
    },
    templateType: function(index) {
      // テンプレートクラス切り替え
      switch (this.pathstep.layoutID) {
        case 10:
          return "card-col2p";
        case 11:
          return "card-col3p";
        case 22:
          return "card-col2p card-voice";
        case 47:
          if (index == 1) {
            return "card-col2p";
          } else {
            return "card-col3p";
          }
        case 48:
          return "card-col2s card-voice";
        case 49:
        case 59:
          return "card-col3s card-voice";
        case 65:
          return "card-col3p2r card-voice";
        case 69:
          return "card-col3s";
        default:
          return "";
      }
    },
    getLangText: function(act) {
      // テキスト取得
      if (this.dispJapaneseStatus == true) {
        // 日本語表示
        return act.japaneseText;
      } else {
        // 英語
        return act.basicText;
      }
    },
    activeCorrectAnswer: function(text) {
      // 全回答表示中、正解欄をアクティブにする
      var answer = this.currentAnswers[this.currentSelectIndex][0];
      if (this.dispAllAnswerStatus == true && answer == text) {
        // 全解答表示中で正解のテキスト
        return true;
      } else {
        // 上記以外
        return false;
      }
    },
    showQuestionText: function(index) {
      // 問題文表示切り替え
      // 日本語表示時は非表示
      if (this.dispJapaneseStatus) {
        return false;
      } else {
        return this.actList[index].isChallenge && !this.finishAct(index) && !this.dispAllAnswerStatus;
      }
    },
    showAnswerText: function(index) {
      // 回答文表示切り替え
      // 日本語表示時は非表示
      if (this.dispJapaneseStatus) {
        return false;
      } else {
        return !(this.actList[index].isChallenge && !this.finishAct(index) && !this.dispAllAnswerStatus);
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let cardClone;
      let textAreaClone;
      let textClone;
      const cloneCard = function(targetText) {
        // カードを複製
        cardClone = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        textAreaClone = cardClone.children(".select");
        textAreaClone.empty();
        textAreaClone.append("<span/>");
        textClone = textAreaClone.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        textClone.html(targetText);
        cardClone.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // カードのフォントサイズを求める
      for (let act of this.actList) {
        // Tile表示で実施
        cloneCard(act.questionText);
        this.usCardAreaFontSize = this.getAutoAdjustFontSize(textAreaClone, textClone, this.usCardAreaFontSize);
        cardClone.remove();
        // 英語で実施
        cloneCard(act.answerText);
        this.usCardAreaFontSize = this.getAutoAdjustFontSize(textAreaClone, textClone, this.usCardAreaFontSize);
        cardClone.remove();
        // 日本語で実施
        cloneCard(act.japaneseText);
        this.jpCardAreaFontSize = this.getAutoAdjustFontSize(textAreaClone, textClone, this.jpCardAreaFontSize);
        cardClone.remove();
      }
      // カードの高さを求める
      for (let act of this.actList) {
        // Tile表示で実施
        cloneCard(act.questionText);
        this.usCardAreaHeight = this.getAutoAdjustHeight(textAreaClone, textClone, this.usCardAreaHeight, this.usCardAreaFontSize);
        cardClone.remove();
        // 英語で実施
        cloneCard(act.answerText);
        this.usCardAreaHeight = this.getAutoAdjustHeight(textAreaClone, textClone, this.usCardAreaHeight, this.usCardAreaFontSize);
        cardClone.remove();
        // 日本語で実施
        cloneCard(act.japaneseText);
        this.jpCardAreaHeight = this.getAutoAdjustHeight(textAreaClone, textClone, this.jpCardAreaHeight, this.jpCardAreaFontSize);
        cardClone.remove();
      }
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.cardAreaHeight;
      let fixedFontSize = fixedSize.cardAreaFontSize;
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item > .select");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
      // 出題文表示領域の高さを調整する
      let topArea = $(".toparea-text");
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      let topAreaPaddingTop = parseInt(topArea.css("padding-top"), 10);
      let topAreaPaddingBottom = parseInt(topArea.css("padding-bottom"), 10);
      topArea.height(rootHeight - headerHeight - footerHeight - cardsContainerHeight - topAreaPaddingTop - topAreaPaddingBottom);
    },
    /**
     * 長押しイベント開始
     *
     * @param String imgpath 画像パス
     */
    onTouchStart: function(imgpath) {
      this.log("Tile start TouchEvent::" + imgpath);
      if (this.isEnvironmentPc()) {
        // PCの場合は表示しない
        return;
      }
      var self = this;

      this.touchTimer = setTimeout(function() {
        self.showPinchInImage(imgpath);
      }, mixinConstants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      this.log("Tile end TouchEvent");
      clearTimeout(this.touchTimer);
    }
  },
  watch: {
    lessonState: function(state) {
      // ステータス処理
      const self = this;
      if (this.waitingStart && state == constants.LESSON_STATE_START) {
        // STARTの場合、初回音声再生
        this.waitingStart = false;
        this.timer = setTimeout(function() {
          self.divideChallenge();
        }, 1000);
      } else if (state == constants.LESSON_STATE_STOP) {
        // レッスン停止の場合
        this.destroyRunmode();
        this.$emit("stopAct");
      } else if (state == constants.LESSON_STATE_PAUSE) {
        // レッスン停止
        if (!this.myAudio.ended && this.myAudio.paused) {
          // 音声停止中の場合
          this.audioPlaying = true;
        }
        // 次のACT停止
        if (this.nextTimer) {
          clearTimeout(this.nextTimer);
        }
      } else if (state == constants.LESSON_STATE_RESTART) {
        // レッスンリスタート
        if (this.nextTimer) {
          this.nextAct();
        } else if (this.isAudioReplay) {
          // リプレイ中
          this.audioPlaying = false;
          this.isAudioReplay = false;
        } else if (this.isCorrectPlaying) {
          // 正解音再生
          this.audioCollectEnded();
        } else if (!this.myAudio.ended && this.myAudio.paused) {
          // 音声未終了で音声停止中
          if (this.myAudio.paused) {
            this.audioPlaying = true;
            this.myAudio.currentTime = 0;
            this.myAudio.play();
          }
        }
      }

      if (!this.isEnvironmentPc()) {
        if (!this.isAutoAdjustShown) {
          // 表示領域自動調整
          this.autoAdjustCardArea();
          this.applyCardAreaSize();
          $(".page-content").animate({ opacity: 1 }, 500);
          this.isAutoAdjustShown = true;
        }
      }
    },
    dispJapaneseStatus: function(newStatus) {
      this.applyCardAreaSize();
    }
  },
  mounted() {
    this.init();

    // 自動調整初期処理
    this.initAutoAdjust([".page-content"], [".page-content"]);
  }
};
</script>
<style scoped lang="scss">
@import "src/assets/style/card";
.toparea-text {
  .item {
    &.active {
      border: solid 2px #81af4a;
    }
  }
}
</style>
<style lang="scss">
.tile .input {
  display: inline-block;
  border: solid 1px $input-bdcolor;
  background: $lgray;
  margin-right: 5px;
  vertical-align: middle;
}
.propPc .tile .input {
  width: 65px;
  height: 22px;
}
.propSp .tile .input {
  width: 40px;
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// Tile.vue?6f6ea458